export default __webpack_public_path__ + "static/media/jpop.631794dd.jpg";